var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.99053e-08 5.68447L1.175 6.82617L5 3.11767L8.825 6.82617L10 5.68447L5 0.826172L-4.99053e-08 5.68447Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBase);
export default __webpack_public_path__ + "static/media/chevron-up_base.ea72df8540c9aa1b3ec4d7e7ad3fe4a9.svg";
export { ForwardRef as ReactComponent };